<template>
  <v-flex>
    <h2>Eliminar</h2>
    <v-flex class="container-info" ma-1 px-3 pt-2>
      <v-flex>
        <p class="mt-1">¿Está seguro que desea eliminar?:</p>
      </v-flex>
      <v-flex>
        <v-flex d-inline-flex>
          <h4 style="color:#BDBDBD;">Misión:</h4>
          <h4 class="pl-2">{{ itemSelected.name }}</h4>
        </v-flex>
        <br/>
        <v-flex d-inline-flex>
          <h4 style="color:#BDBDBD;">Descripción:</h4>
          <h4 class="pl-2">{{ itemSelected.description }}</h4>
        </v-flex>
        <br/>
        <v-flex d-inline-flex>
          <h4 style="color:#BDBDBD;">Duración Misión:</h4>
          <h4 class="pl-2">
            {{
              `${itemSelected.startDateUnique} ${itemSelected.startTimeUnique}` | filterFullDate
            }}
          </h4>
          <v-flex class="pl-2">-</v-flex>
          <h4 class="pl-2">
            {{
              `${itemSelected.endDateUnique} ${itemSelected.endTimeUnique}` | filterFullDate
            }}
          </h4>
        </v-flex>
      </v-flex>
      <v-flex d-inline-flex mt-3>
        <p><v-icon class="pr-1" small>warning</v-icon>Tener en cuenta que esta acción afectará</p>
        <h3 class="pl-2">{{ itemSelected.vehiclesInMission }}</h3>
        <p class="pl-2">
          {{ itemSelected.vehiclesInMission === 1 ? 'vehículo' : 'vehículos' }}
        </p>
      </v-flex>
      <v-flex 
        v-if="requestPendingToUpdate" 
        class="message-reload-pending" 
        pl-3
        mb-2
      >
        <v-flex d-inline-flex align-center>
          <v-flex>
            <v-icon left color="grey darken-3">warning</v-icon>
          </v-flex>
          <v-flex class="caption font-weight-medium">
            Requerde que la Minuta de Servicios ha cambiado, y es recomendado que se recarguen los datos de la consulta actual.
          </v-flex>
          <v-flex>
            <v-btn
              flat
              icon
              color="grey darken-3"
              @click="reloadData"
            >
              <v-icon>replay</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-flex>
      <v-flex style="margin-top:-20px;">
        <v-checkbox
          v-model="agreeAction"
          label="Si"
          @change="changeAction"
        />
      </v-flex>
    </v-flex>
    <!-- JUSTIFICATION -->
    <v-flex v-if="agreeAction" mt-2>
      <p>¿Por qué desea eliminar la misión?</p>
      <!-- TEXT AREA -->
      <!-- :disabled="disabledCancel" -->
      <!-- @input="textInputAction"÷ -->
      <v-textarea
        v-model="observationInput"
        box
        name="observations"
        label="Justificación"
        @input="textInputAction"
      ></v-textarea>
      <!-- ACTION BUTTON -->
      <v-flex d-flex>
        <v-btn
          color="primary"
          :disabled="justificationComputed"
          @click="deleteMissionIn"
          :loading="$loading.isLoading('deleteMission')"
        >
          <v-icon left>delete_forever</v-icon>
          Eliminar Misión
        </v-btn>
      </v-flex>
    </v-flex>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex'

import { missionInProgressMixin } from '../../../mixins/missionInProgressMixin.js'

export default {
  name: 'delete-mission',
  mixins: [missionInProgressMixin],
  props: ['itemSelected', 'requestPendingToUpdate'],
  data() {
    return {
      observationInput: '',
      agreeAction: false
    }
  },
  computed: {
    justificationComputed() {
      let result = true
      if (!this.agreeAction) result = false
      else if (this.agreeAction && this.observationInput !== '') result = false
      return result
    }
  },
  methods: {
    ...mapActions(['deleteMission']),
    reloadData() {
      this.$emit('reload')
      this.$emit('finishAction')
    },
    async deleteMissionIn() {
      // console.log('ELIMINAR MISSION')
      const response = await this.deleteMission({
        id: this.itemSelected.missionID,
        deletedWhy: this.observationInput
      })
      // console.log('terminateMissionIn RESPONSE', response)
      if (response.data.success) {
        this.observationInput = ''
        this.agreeAction = false
        this.$emit('finishAction')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.message-reload-pending
  color #424242
  background-color #FFB300
  border-radius 3px
  max-width 340px
  height 45px
  line-height 11px

.container-info
  background-color #616161
  border-radius 5px

</style>



// WEBPACK FOOTER //
// src/components/Missions/ActionsMissions/DeleteMission.vue